import { ComparisonPeriod, DisplayType, IndicatorType } from 'domain/kpis/types';

export interface KpiTemplate {
  name: string;
  unitOfMeasure: string;
  displayType: DisplayType;
  description?: string;
  trendIndicator: IndicatorType;
  showXAxis: boolean;
  showYAxis: boolean;
  comparisonEnabled: boolean;
  comparisonPeriod: ComparisonPeriod;
  visibility: 'Public' | 'Private';
}

export const KPI_TEMPLATES: KpiTemplate[] = [
  {
    name: 'Monthly Recurring Revenue',
    unitOfMeasure: '$',
    displayType: 'LineChart',
    description: 'MRR growth trend',
    trendIndicator: 'Up',
    showXAxis: true,
    showYAxis: true,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
  {
    name: 'Customer Count',
    unitOfMeasure: '',
    displayType: 'LineChart',
    description: 'Total customers over time',
    trendIndicator: 'Up',
    showXAxis: true,
    showYAxis: true,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
  {
    name: 'Churn Rate',
    unitOfMeasure: '%',
    displayType: 'LineChart',
    description: 'Customer churn percentage',
    trendIndicator: 'Down',
    showXAxis: true,
    showYAxis: true,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
  {
    name: 'Customer Acquisition Cost',
    unitOfMeasure: '$',
    displayType: 'NumberIndicator',
    description: 'Cost to acquire a customer',
    trendIndicator: 'Down',
    showXAxis: false,
    showYAxis: false,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
  {
    name: 'Units Sold',
    unitOfMeasure: '',
    displayType: 'LineChart',
    description: 'Total units sold over time',
    trendIndicator: 'Up',
    showXAxis: true,
    showYAxis: true,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
  {
    name: 'Cash Runway',
    unitOfMeasure: 'months',
    displayType: 'NumberIndicator',
    description: 'Months until cash runs out',
    trendIndicator: 'Up',
    showXAxis: false,
    showYAxis: false,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
  {
    name: 'Burn Rate',
    unitOfMeasure: '$',
    displayType: 'BarChart',
    description: 'Monthly cash consumption',
    trendIndicator: 'Down',
    showXAxis: true,
    showYAxis: true,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
  {
    name: 'Average Revenue Per User',
    unitOfMeasure: '$',
    displayType: 'LineChart',
    description: 'ARPU over time',
    trendIndicator: 'Up',
    showXAxis: true,
    showYAxis: true,
    comparisonEnabled: true,
    comparisonPeriod: 'Month',
    visibility: 'Private',
  },
];
